import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Modal } from '@src/elements/modal/modal'
import { Button } from '@src/elements/button/button'
import { NotificationTypes } from '@src/util/constants'
import { Body1 } from '@src/elements/typography/typography'

import './confirm-modal.sass'

@Component
export class ConfirmModal extends Vue {

  @Prop({ required: true })
  show: boolean

  @Prop({ required: false, default: '' })
  message: string

  @Prop({ required: false, default: NotificationTypes.NOTIFY })
  type: string

  @Prop({ required: true })
  closeCallback: (close?: boolean) => void

  constructor () {
    super()
  }

  render (h: CreateElement) {
    return <Modal show={this.show} closeCallback={this.closeCallback} overflow={'hidden'} cssClass={'confirm-modal'}>
      <Body1>{this.message}</Body1>

      {this.type === NotificationTypes.CONFIRM ?
        <div class='btn-row' slot='footer'>
          <Button type='outline' label={this.$t('NO')} click={this.closeCallback} class='no' />
          <Button type='elevated' label={this.$t('YES')} click={() => this.closeCallback(true)} class='yes' />
        </div> : null}
    </Modal>
  }
}
